import React, { Fragment } from "react";

const ModelExportDescription = props => (
  <Fragment>
    <div className="f4 b mb2">{props.t("pdf:pdfLabelDescription")}</div>

    <div className="mb2">
      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelMaker")}</span> Ober Surfaces
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelSurface")}</span> {props.surfaceBrand.titlePart1} -{" "}
        {props.surface.title}
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelPerforationRate")}</span> «{
          props.pattern.title
        }»<sup>(1)</sup> - {props.patternCollectionTitle}
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelSupport")}</span> {props.t("pdf:pdfLabelSupportMDF16")}
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelContreface")}</span> {props.t("pdf:pdfLabelContrefaceVoileNoir")}
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelSize")}</span>&nbsp;{props.t("pdf:pdfLabelSizeContent")}
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelThickness")}</span>{" "}
        {props.surface.thickness || props.surfaceBrand.thicknessByDefaut}
      </div>

      <div className="mb02 f7">
        <span className="b">{props.t("pdf:pdfLabelFireClassification")}</span> M1
      </div>
      <div className="f7">
        <span className="b f7">{props.t("pdf:pdfLabelSurfaceResistance")}</span>&nbsp;{props.t("pdf:pdfLabelSurfaceResistanceNorme")}
      </div>
    </div>

    <div className="mb2">{/*      Lien vers la référence*/}</div>

    <div className="f8 mb2">
      <div className="mb02">(1) {props.t("pdf:pdfLabelRegisteredDesign")}</div>
      <div className="mb02">
        (2) {props.t("pdf:pdfLabelCustomSizes")}
      </div>
    </div>

    <div className="f8 b">
      {props.t("pdf:pdfLabelNB")}
    </div>
  </Fragment>
);

export default ModelExportDescription;



// WEBPACK FOOTER //
// ./src/components/ModelExportDescription.js